<template>
  <div id="ChartCriteria" class="row no-gutters">
    <div class="col">
      <form accept-charset="UTF-8" enctype="multipart/form-data" autocomplete="off" class="form" action="#" method="post" novalidate="novalidate" id="ChartGenerateFormId">
        <div class="mt-3">
          <div v-if="!display" class="container pt-2">
            <chart-criteria-skeleton />
          </div>
          <div v-if="display" class="container pt-2">
            <div class="show-hide-links">
              <div :class="isExplorePage ? 'chart-criteria-section-1-explorer-page' : 'chart-criteria-section-1'" style="border-right: none;">
                <div class="chart-segment-options">
                  <modal-link modal-id="Period/Group Options" :content-list="pageContent"></modal-link>
                  <a href="#" v-show="!displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Show Period/Group Options<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Hide Period/Group Options<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
              <div v-show="isComparative" class="chart-criteria-section-2-match-page">
                <div class="chart-segment-options">
                  <modal-link modal-id="Analytics Options" :content-list="pageContent"></modal-link>
                  <a href="#" v-show="!displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Show Analytics Options<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Hide Analytics Options<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
              <div v-show="!isComparative && !showNpsTrends" :class="isExplorePage ? 'explore-middle-section' : 'chart-criteria-section-2'" style="border-right: none;">
                <div class="chart-segment-options">
                  <modal-link modal-id="Analytics Options" :content-list="pageContent"></modal-link>
                  <a href="#" v-show="!displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Show Analytics Options<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Hide Analytics Options<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
              <div :class="isExplorePage ? 'col pl-2': 'chart-criteria-section-3'">
                <div class="chart-segment-options">
                  <modal-link modal-id="Segment Options" :content-list="pageContent"></modal-link>
                  <a href="#" v-show="!displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Show Segment Options<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Hide Segment Options<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div :class="isExplorePage ? 'chart-criteria-section-1-explorer-page' : 'chart-criteria-section-1'">
                  <div v-show="displayChartCriteriaPeriod" class="w-100">
                    <div v-show="showDisplayType && !useChartTypeCard" class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <!--
                        <modal-link v-if="!useChartTypeCard" :modal-id="displayTypeModalName" :content-list="pageContent"></modal-link>
                        -->
                        <label v-if="!useChartTypeCard" for="display_type" class="sub-heading-label">{{ displayTypeLabel }}</label>
                      </div>
                      <div v-if="!useChartTypeCard" class="chart-criteria-field-column">
                        <select
                          id="display_type"
                          name="display_type"
                          class="custom-select required shadow w-100"
                          :disabled="disableChartCriteriaWidgets"
                          v-on:change="saveValue($event, 'Display Type', 'display_type', true)"
                          v-model="displayType"
                        >
                          <option value="">Select</option>
                          <option v-for="(option, idxDisplayTypeOptions) in display_type_options" v-bind:value="option.value" v-bind:key="idxDisplayTypeOptions">
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>                
                    <div v-show="showMetric && !showNpsTrends" class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <label for="metric" class="sub-heading-label pt-1 my-auto">vs. Metric</label>
                      </div>
                      <div class="chart-criteria-field-column">
                        <select
                          id="metric"
                          name="metric"
                          :class="showMetric && !showNpsTrends ? 'custom-select required shadow w-100' : 'custom-select shadow'"
                          :disabled="disableChartCriteriaWidgets"
                          v-on:change="saveValue($event, 'Metric', 'metric', true)"
                          v-model="metric"
                        >
                          <option value="">Select</option>
                          <option v-for="(option, idxMetricOptions) in metric_options" v-bind:value="option.value" v-bind:key="idxMetricOptions">
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-show="showMatchType" class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <label for="match_type" class="sub-heading-label pt-1 my-auto">{{ matchTypeLabel }}</label>
                      </div>
                      <div class="chart-criteria-field-column">
                        <select
                          id="match_type"
                          name="match_type"
                          :class="showMatchType ? 'custom-select required shadow w-100' : 'custom-select shadow w-100'"
                          :disabled="disableChartCriteriaWidgets"
                          v-on:change="saveValue($event, 'Match Type', 'match_type', true)"
                          v-model="matchType"
                        >
                          <option value="">Select</option>
                          <option v-for="(option, idxMatchTypeOptions) in match_type_options" v-bind:value="option.value" v-bind:key="idxMatchTypeOptions">
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-show="!displayComparativePeriod" class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <!--
                        <modal-link modal-id="Period" :content-list="pageContent"></modal-link>
                        -->
                        <label for="period" class="sub-heading-label">{{ timePeriodLabel }}</label>
                      </div>
                      <div :class="showEndPeriod ? 'chart-criteria-field-column d-flex' :   'chart-criteria-field-column'">
                        <select
                          id="period"
                          name="period"
                          :class="showEndPeriod ? 'custom-select required shadow custom-select-fixed-width' : 'custom-select required shadow w-100 col-12'"
                          :disabled="disableChartCriteriaWidgets"
                          v-on:change="saveTimePeriodEvent($event, 'Period', 'period', true)"
                          v-model="period"
                        >
                          <option value="">Select</option>
                          <option v-for="(option, idxPeriodOptions) in period_options" v-bind:value="option.value" v-bind:key="idxPeriodOptions">
                            {{ option.name }}
                          </option>
                        </select>
                        <div v-show="showEndPeriod" class="col-8 d-flex no-gutters">
                          <div v-show="showEndPeriod" class="col-4 pr-1">
                            <label for="endPeriod" class="sub-heading-label pt-2 my-auto">End Period</label>
                          </div>
                          <div v-show="showEndPeriod" class="col"> 
                              <select
                                id="endPeriod"
                                name="endPeriod"
                                :class="showEndPeriod ? 'custom-select required shadow custom-select-fixed-width' : 'custom-select shadow custom-select-fixed-width'"
                                :disabled="disableChartCriteriaWidgets"
                                v-on:change="saveTimePeriodEvent($event, 'End Period', 'endPeriod', true)"
                                v-model="endPeriod"
                              >
                                <option value="">Select</option>
                                <option v-for="(option, idxPeriodOptions) in period_options" v-bind:value="option.value" v-bind:key="idxPeriodOptions">
                                  {{ option.name }}
                                </option>
                              </select>
                          </div>
                        </div>                    
                      </div>
                    </div>
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column"></div>
                      <div class="chart-criteria-field-column">
                        <div v-show="showUseTTMAsStartDate" class="form-group">
                          <input
                            id="useTTMAsStartDate"
                            name="useTTMAsStartDate"
                            type="checkbox"
                            true-value="Y"
                            false-value="N"
                            v-model="useTTMAsStartDate"
                            @click="saveCheckboxValue($event, 'Use TTM as Data Start Date', 'use_ttm_as_data_start_date', true)"
                          />
                          <span class="ml-1 mr-1">Use TTM as Data Start Date</span>
                        </div>                
                        <div v-show="!displayComparativePeriod && showCustomTimePeriod && displayCustomTimePeriod" class="form-group">
                          <input
                            id="customTimePeriod"
                            name="customTimePeriod"
                            type="checkbox"
                            true-value="Y"
                            false-value="N"
                            v-model="customTimePeriod"
                            @click="saveCheckboxValue($event, 'Custom Time Period', 'custom_time_period', true)"
                          />
                          <span class="ml-1 mr-1">Custom Time Period</span>
                            <div v-show="displayCustomDateFields" class="chart-criteria-row w-100">
                              <div class="chart-criteria-label-column">
                                <label for="customStartDate" class="sub-heading-label">Start Date</label>
                              </div>
                              <datepicker format="MMM dd yyyy" v-model="customStartDate" @selected="saveDateValue($event, 'Custom Start Date', 'custom_start_date', true)" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="customStartDate"></datepicker>
                            </div>
                            <div v-show="displayCustomDateFields" class="chart-criteria-row w-100">
                              <div class="chart-criteria-label-column">
                                <label for="customEndDate" class="sub-heading-label">End Date</label>
                              </div>
                              <datepicker format="MMM dd yyyy" v-model="customEndDate" @selected="saveDateValue($event, 'Custom End Date', 'custom_end_date', true)" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="customEndDate"></datepicker>
                            </div>
                        </div>
                        <div class="form-group">
                          <input
                            id="includePartialResponses"
                            name="includePartialResponses"
                            type="checkbox"
                            true-value="Y"
                            false-value="N"
                            v-model="includePartialResponses"
                            @click="saveCheckboxValue($event, 'Include Partial Responses', 'include_partial_responses', true)"
                          />
                          <span class="ml-1 mr-1">Include Partial Responses</span>
                        </div>
                      </div>
                    </div>                  
                    <div v-show="displaySingleSelectSurveyGroups" class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <!--
                        <modal-link modal-id="Survey Group" :content-list="pageContent"></modal-link>
                        -->
                        <label for="surveyGroup" class="sub-heading-label">Group</label>
                      </div>
                      <div class="chart-criteria-field-column">
                        <select
                          id="surveyGroup"
                          name="surveyGroup"
                          class="custom-select shadow w-100"
                          :disabled="disableChartCriteriaWidgets"
                          v-on:change="saveValue($event, 'Survey Group', 'survey_group', true);setUseEqualWeight();"
                          v-model="surveyGroup"
                        >
                          <option value="">None</option>
                          <option v-for="(option, idxSurveyGroupOptions) in survey_group_options" v-bind:value="option.value" v-bind:key="idxSurveyGroupOptions">
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-show="displaySingleSelectSurveyGroups" class="chart-criteria-row">
                      <div class="chart-criteria-label-column"></div>
                      <div class="chart-criteria-field-column">
                          <div class="form-group">
                            <input 
                              id="showPublicGroups" 
                              name="showPublicGroups" 
                              type="checkbox" 
                              true-value="Y" 
                              false-value="N" 
                              v-model="showPublicGroups" 
                              @click="saveCheckboxValue($event, 'Show Public Groups', 'show_public_groups', true)"
                              />
                            <span class="ml-1 mr-1">Show Public Groups</span>
                          </div>                  
                          <div v-show="showEqualWeight" class="form-group">
                            <input 
                              id="useEqualWeight" 
                              name="useEqualWeight" 
                              type="checkbox" 
                              :disabled="disableEqualWeight"
                              true-value="Y" 
                              false-value="N" 
                              v-model="useEqualWeight" 
                              @click="saveCheckboxValue($event, 'Calculate Surveys Equal-Weighted', 'use_equal_weight', true)"
                              />
                            <span class="ml-1 mr-1">Calculate Surveys Equal-Weighted</span>
                          </div>
                          <div v-show="showIncludeOrganizationSelectedInGroupRanks" class="form-group">
                            <input
                              id="includeOrganizationSelectedInGroupRanks"
                              name="includeOrganizationSelectedInGroupRanks"
                              type="checkbox"
                              true-value="Y"
                              false-value="N"
                              :disabled="disableIncludeOrganizationSelectedInGroupRanks"  
                              v-model="includeOrganizationSelectedInGroupRanks"
                              @click="saveCheckboxValue($event, 'Include Organization Selected in Group Ranks', 'include_organization_selected_in_group_ranks', true)"
                            />
                            <span class="ml-1">Include Organization in Group Ranks</span>
                          </div>
                      </div>
                    </div>
                    <div v-if="isProfilePage && !isNps && !isMoneyballStick" class="form-row pt-2 pl-1">
                      <div class="chart-criteria-label-column">
                        <!--
                        <modal-link modal-id="Road Map" :content-list="pageContent"></modal-link>
                        -->
                        <label class="sub-heading-label">Road Map</label>
                      </div>
                      <div class="chart-criteria-field-column">
                        <div class="form-group">
                          <input
                            id="showRoadMapInitiatives"
                            name="showRoadMapInitiatives"
                            type="checkbox"
                            true-value="Y"
                            false-value="N"
                            v-model="showRoadMapInitiatives"
                            @click="saveCheckboxValue($event, 'Show Initiatives by Need', 'show_roadmap_initiatives', true)"
                          />
                          <span class="ml-1 mr-1">Show Initiatives by Need</span>
                        </div>
                        <div class="form-group m-1 align-items-center row">
                            <label for="roadMap" class="m-0 p-0 col-3">Map</label>
                            <select
                            id="roadMapInitiative"
                            name="roadMapInitiative"
                            class="custom-select shadow w-100 col-9"
                            :disabled="disableRoadMapInitiativesFields"
                            v-model="roadMapInitiative"
                            @change="selectRoadMapInitiative"
                            >
                              <option :value="defaultRoadMapInitiative">{{ defaultRoadMapInitiative }}</option>
                              <option v-for="(option, idxRoadMapInitiativesOptions) in roadmap_initiatives_options" v-bind:value="option.value" v-bind:key="idxRoadMapInitiativesOptions">
                                {{ option.name }}
                              </option>
                            </select>
                        </div>
                      </div>
                    </div>
                  </div>                
              </div>
              <div v-show="isComparative" class="chart-criteria-section-2-match-page chart-criteria-border">
                <div v-show="displayChartCriteriaAnalytics" class="w-100">
                  <div v-show="displaySavedCards" class="form-group">
                    <label for="savedCards" class="sub-heading-label pt-1 my-auto">Saved Card</label>
                    <div class="">
                      <multiselect
                        v-model="comparativeSavedCards"
                        :options="saved_card_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        name="comparative-saved-cards"
                        track-by="name"
                        :preselect-first="false"
                        :max="maximumComparative"
                        @select="onComparativeInput($event, 'saved-card')"
                        @remove="onComparativeRemove($event, 'saved-card')"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="comparative-saved-cards" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                    <div class="form-group pt-2">
                      <!--
                      <modal-link modal-id="Show All Chart Cards" :content-list="pageContent"></modal-link>
                      -->
                      <input id="showAllChartCards" name="showAllChartCards" type="checkbox" true-value="Y" false-value="N" v-model="showAllChartCards" />
                      <span class="ml-1 mr-1">Show All Chart Cards</span>
                    </div>
                  </div>
                  <div v-show="displayComparativePeriod" class="form-group">
                    <label for="period" class="sub-heading-label pt-1 my-auto">{{ timePeriodLabel }}</label>
                    <div class="">
                      <multiselect
                        v-model="comparativePeriods"
                        :options="period_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        name="comparative-period"
                        track-by="name"
                        :preselect-first="false"
                        :max="maximumComparative"
                        @select="onComparativeInput($event, 'time-period')"
                        @remove="onComparativeRemove($event, 'time-period')"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="comparative-period" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-show="displayMultiSelectSurveyGroups" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <!--
                      <modal-link modal-id="Survey Group" :content-list="pageContent"></modal-link>
                      -->
                      <label for="surveyGroup" class="sub-heading-label">Groups to Match</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <multiselect
                        v-model="comparativeSurveyGroups"
                        :options="survey_group_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="None"
                        label="name"
                        name="comparative-survey-group"
                        track-by="name"
                        :preselect-first="false"
                        :max="maximumComparative"
                        @select="onComparativeInput($event, 'survey-group')"
                        @remove="onComparativeRemove($event, 'survey-group')"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="comparative-survey-group" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-show="displayMultiSelectSurveyGroups" class="chart-criteria-row">
                      <div class="chart-criteria-label-column"></div>
                      <div class="chart-criteria-field-column">
                        <div class="form-group">
                          <input 
                            id="showPublicGroups" 
                            name="showPublicGroups" 
                            type="checkbox" 
                            true-value="Y" 
                            false-value="N" 
                            v-model="showPublicGroups" 
                            @click="saveCheckboxValue($event, 'Show Public Groups', 'show_public_groups', true)"
                          />
                          <span class="ml-1 mr-1">Show Public Groups</span>
                        </div>                  
                        <div class="form-group">
                          <input 
                            id="useEqualWeightForComparativeSurveyGroups" 
                            name="useEqualWeightForComparativeSurveyGroups" 
                            type="checkbox" 
                            true-value="Y" 
                            false-value="N" 
                            :disabled="disableEqualWeightForComparativeSurveyGroups"
                            v-model="useEqualWeight" 
                            @click="saveCheckboxValue($event, 'Calculate Surveys Equal-Weighted', 'use_equal_weight', true)"
                            />
                          <span class="ml-1 mr-1">Calculate Surveys Equal-Weighted</span>
                        </div>
                      </div>
                  </div>
                  <div v-show="displayComparativeSurvey" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <label for="survey" class="sub-heading-label pt-1 my-auto">Surveys to Match</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <multiselect
                        v-model="comparativeSurveys"
                        :options="survey_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        name="comparative-survey"
                        track-by="name"
                        :preselect-first="false"
                        :max="maximumComparative"
                        @select="onComparativeInput($event, 'survey')"
                        @remove="onComparativeRemove($event, 'survey')"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="comparative-survey" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="!isComparative && !showNpsTrends" :class="isExplorePage ? 'explore-middle-section chart-criteria-border' : 'chart-criteria-section-2'">
                <div v-show="displayChartCriteriaAnalytics" class="w-100">
                  <div v-show="showCompetitors && hasCompetitors" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <!--
                      <modal-link modal-id="Competitors" :content-list="pageContent"></modal-link>
                      -->
                      <label class="sub-heading-label">Competitors</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <multiselect
                        ref="competitorsSelect"
                        v-model="values"
                        :disabled="disableChartCriteriaWidgets"
                        :options="competitor_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        :max="maximumCompetitors"
                        name="multi-competitor"
                        track-by="companyId"
                        :preselect-first="false"
                        @select="addCompany"
                        @remove="removeCompany"
                      >
                      <template slot="maxElements"
                          ><span style="color: #e54d42">{{ maximumCompetitorMessage }}</span></template
                        >
                        <template #option="props">
                          <span class="checkbox-label"  @click.self="select(props.option)">
                            <input name="multi-competitor" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-show="isRanks" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <label class="sub-heading-label"># of Ranking Tiers</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <select
                        id="ranking_tier"
                        name="ranking_tier"
                        class="custom-select shadow w-100"
                        :disabled="disableChartCriteriaWidgets"
                        v-on:change="saveValue($event, '# of Ranking Tiers', 'ranking_tier', true)"
                        v-model="ranking_tier"
                      >
                        <option value="">Select</option>
                        <option v-for="(option, idxRankingTiersOptions) in number_of_ranking_tiers_options" v-bind:value="option.value" v-bind:key="idxRankingTiersOptions">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-show="isRanks" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <label class="sub-heading-label">Show Needs</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <multiselect
                        v-model="showNeeds"
                        :disabled="disableChartCriteriaWidgets"
                        :options="filteredShowNeedsOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        name="show-needs"
                        track-by="name"
                        @select="addNeed"
                        @remove="removeNeed"
                        :preselect-first="false"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="show-needs" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-show="isRanks" class="chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <label class="sub-heading-label">Show Metrics</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <multiselect
                        v-model="showMetricGroups"
                        :options="show_metric_groups_options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        select-label=""
                        deselect-label=""
                        selected-label=""
                        placeholder="Select"
                        label="name"
                        name="show-metrics"
                        track-by="name"
                        :disabled="disableChartCriteriaWidgets"
                        @select="addMetric"
                        @remove="removeMetric"
                      :preselect-first="false"
                      >
                        <template #option="props">
                          <span class="checkbox-label" @click.self="select(props.option)">
                            <input name="show-metrics" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                            {{ props.option.name }}
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div v-show="isRanks && displayUseRankCalculations" class="chart-criteria-row">
                    <label class="sub-heading-label pt-1 pl-0 pr-0 my-auto">Use Rank Calculations</label>
                    <select
                      id="use_rank_calculations"
                      name="use_rank_calculations"
                      class="custom-select shadow"
                      :disabled="disableChartCriteriaWidgets"
                      v-on:change="saveValue($event, 'Use Rank Calculations', 'rank_calculation_type', true)"
                      v-model="rank_calculation_type"
                    >
                      <option value="">Select</option>
                      <option v-for="(option, idxUseRankCalculations) in use_rank_calculations_options" v-bind:value="option.value" v-bind:key="idxUseRankCalculations">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                  <div class="chart-criteria-row">
                    <div class="chart-criteria-label-column"></div>
                    <div class="chart-criteria-field-column">
                      <div class="form-group" v-if="includeShowCompetitorExpectations && !isMoneyballStick && !isValueRoadmap">
                        <input
                          id="showCompetitorExpectations"
                          name="showCompetitorExpectations"
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                          v-model="showCompetitorExpectations"
                          @click="saveCheckboxValue($event, 'Show Competitor Expectations', 'Show Competitor Expectations', true)"
                        />
                        <span class="ml-1 mr-1">Show Competitor Expectations</span>
                      </div>
                      <div v-show="displayShowW30Benchmarks" class="form-group">
                        <input id="displayCompetitorsOption" name="displayCompetitorsOption" type="checkbox" v-model="displayBenchmark" @click="logChartClickEvent('Show Benchmarks',displayBenchmark)"/>
                        <span class="ml-1 mr-1">Add Benchmarks</span>
                      </div>
                    </div>
                  </div>
                  <!-- Predictive Analytics deck START -->
                  <div v-if="(isProfilePage && !isNps && !isMoneyballStick ) || isExplorePage" :class=" isExplorerPage ? 'chart-criteria-row' : 'form-row pl-2'">
                    <div class="chart-criteria-label-column">
                      <!--
                      <modal-link modal-id="Predictive Analytics" :content-list="pageContent"></modal-link>
                      -->
                      <label class="sub-heading-label">Advanced <br/> Analytics</label>
                    </div>
                    <div class="chart-criteria-field-column">
                      <div class="form-group" v-if="includeShowPricingPower && !isNps && !isMoneyballStick && !isValueRoadmap">
                        <input
                          id="showPricingPower"
                          name="showPricingPower"
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                          v-model="showPricingPower"
                          @click="saveCheckboxValue($event, 'Show Willingness to Pay by Need', 'show_pricing_power', true)"
                        />
                        <span class="ml-1 mr-1">Show Willingness to Pay by Need</span>
                      </div>
                      <div class="form-group">
                        <input
                          id="showGrowthIdeas"
                          name="showGrowthIdeas"
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                          v-model="showGrowthIdeas"
                          :disabled="disableShowFields"
                          @click="saveCheckboxValue($event, 'Show Growth Ideas', 'show_growth_ideas', true)"
                        /><span class="ml-1 mr-1">Show Growth Ideas by Need</span>
                      </div>
                      <div class="form-group">
                        <input
                          id="showGrowthMetrics"
                          name="showGrowthMetrics"
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                          v-model="showGrowthMetrics"
                          :disabled="disableShowFields"
                          @click="saveCheckboxValue($event, 'Show Growth Metrics', 'show_growth_metrics', true)"
                        />
                        <span class="ml-1 mr-1">Show Predictive Metrics by Need</span>
                      </div>
                        <div v-if="isProfilePage && !isNps && !isMoneyballStick " class="form-group m-1 align-items-center row">
                          <label for="showPeriod" class="m-0 p-0 col-3">Show Period</label>
                          <select
                          id="showPeriod"
                          name="showPeriod"
                          class="custom-select shadow w-100 col-9"
                          :disabled="disableGrowthMetricsFields"
                          v-model="showPeriod"
                          @change="selectShowPeriod"
                          >
                            <option value="">Select</option>
                            <option v-for="(option, idxPeriodOptions) in period_options" v-bind:value="option.value" v-bind:key="idxPeriodOptions">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>
                      <div class="form-group">
                        <input
                          id="showRelationshipStrength"
                          name="showRelationshipStrength"
                          type="checkbox"
                          true-value="Y"
                          false-value="N"
                          v-model="showRelationshipStrength"
                          :disabled="disableShowFields"
                          @click="saveCheckboxValue($event, 'Show Relative Strength', 'show_relative_strength', true)"
                        />
                        <span class="m-1">Show Relative Strength by Need</span>
                        <div v-if="isProfilePage && !isNps && !isMoneyballStick " class="form-group m-1 align-items-center row">
                          <label for="metric" class="m-0 p-0 col-3">Metrics</label>
                          <select
                          id="showMetricGroupsByNeed"
                          name="showMetricGroupsByNeed"
                          class="custom-select shadow w-100 col-9"
                          :disabled="disableRelationshipStrengthFields"
                          v-model="selectedMetricGroupByNeed"
                          @change="selectMetricGroupByNeed"
                          >
                            <option value="">Select</option>
                            <option v-for="(option, idxMetricOptions) in show_metric_groups_options" v-bind:value="option.value" v-bind:key="idxMetricOptions">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>
                        <div v-if="isProfilePage && !isNps && !isMoneyballStick" class="form-group m-1 align-items-center row">
                          <label for="startPeriod" class="m-0 p-0 col-3">Start Period</label>
                          <select
                          id="startPeriod"
                          name="startPeriod"
                          class="custom-select shadow w-100 col-9"
                          :disabled="disableRelationshipStrengthFields"
                          v-model="startPeriod"
                          @change="selectStartPeriod"
                          >
                            <option value="">Select</option>
                            <option v-for="(option, idxPeriodOptions) in period_options" v-bind:value="option.value" v-bind:key="idxPeriodOptions">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Predictive Analytics deck END -->
                </div>                
              </div>
              <div :class="isExplorePage ? 'col pl-2': 'chart-criteria-section-3'">
                <div v-show="displayChartCriteriaSegments" class="segments row no-gutters">
                  <div v-for="(chartCriteria, idxSegments) in segments" v-bind:key="idxSegments" class="col-lg-6 col-sm-12 pt-1 pb-1">
                    <chart-criteria-option
                      placeholder="Select"
                      option-type="multiselect"
                      label-class="sub-heading-label"
                      v-bind:option-object="chartCriteria"
                      :resetOption="resetOption"
                      :chartTitle="$parent.chart.title"
                      :surveyName="surveyName"
                      :content-list="pageContent"
                      @add="saveResultValue"
                    ></chart-criteria-option>
                  </div>
                  <div class="d-none col-lg-6 col-sm-12">
                    <div class="form-group">
                      <!--
                      <modal-link modal-id="Location" :content-list="pageContent"></modal-link>
                      -->
                      <label for="survey_location" class="control-label pt-1 pr-1 my-auto">Location</label>
                      <a class="mr-1" href="#" @click="showPopup">Click to View Counts</a>
                      <Treeselect
                        :model-value="surveyLocation"
                        @update:modelValue="onInput"
                        :is-independent-nodes="true"
                        :is-single-select="false"
                        :alwaysOpen="false"
                        :show-count="false"
                        :default-expand-level="1"
                        :options="survey_location_options"
                        :append-to-body="true"
                        :required="false"
                        :clearable="false"
                        :maxHeight="400"
                        name="survey_location"
                        placeholder="Select"
                      />                                       
                    </div>
                  </div>
                  <div v-show="!showExclusionList" class="col-lg-6 col-sm-12 pt-1 pb-1">
                    <div class="chart-criteria-row">
                      <div class="chart-criteria-label-column">
                        <label for="word" class="" style="color: #2f5eb3">Word</label>
                      </div>
                      <div class="col-9">
                        <Treeselect
                          :model-value="words"
                          @update:modelValue="onInputWords"
                          :is-independent-nodes="true"
                          :is-single-select="false"
                          :alwaysOpen="false"
                          :show-count="false"
                          :default-expand-level="1"
                          :options="word_options"
                          :append-to-body="true"
                          :required="false"
                          :clearable="false"
                          :maxHeight="400"
                          name="word"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
            <chart-company v-show="displayChartCriteriaAnalytics" ref="chartCompany" :client-id="clientId" :input-page-content="pageContent"></chart-company>
            <div class="form-row">
              <div v-show="showDisplayType" class="form-group">
                  <!--
                  <modal-link v-if="useChartTypeCard" :modal-id="displayTypeModalName" :content-list="pageContent"></modal-link>
                  -->
                  <label v-if="useChartTypeCard" for="display_type" class="control-label pt-1 pr-1 my-auto">{{ displayTypeLabel }}</label>
                  <div v-if="useChartTypeCard" class="d-flex justify-content-left flex-wrap">
                    <chart-type-card
                      v-for="(option, idxChartTypeCardOptions) in display_type_options"
                      :chart-type="option.value"
                      :display-name="option.name"
                      :current-display-type="displayType"
                      @select="setDisplayType"
                      v-bind:key="idxChartTypeCardOptions"
                    ></chart-type-card>
                  </div>
              </div>
              <div class="d-flex btn-group-horizontal align-items-center pl-2 pt-3" role="group">
                <button type="submit" class="btn btn-primary mr-2" v-on:click="runChart">
                  <span>{{ generateLabel }}</span>
                  <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
                </button>
                <button v-show="showExclusionList" type="submit" class="btn btn-primary mr-2" v-on:click="showManageExclusionListModal">Manage Exclusive List</button>
                <button type="submit" class="btn btn-primary" v-on:click="resetChartCriteria">Reset</button>
                <div v-show="!$parent.generatingChart && $parent.displayView" class="show-hide-chart-criteria-results ml-2">
                  <button id="save_chart" class="btn btn-primary mr-2" type="button" @click="$modal.show('save-chart-confirmation')" :disabled="$parent.disableSaveAsCardButton">Save as Card</button>
                  <!--
                  <modal-link modal-id="Show Chart Criteria Selections" :content-list="pageContent"></modal-link>
                  -->
                  <button v-show="isRanks && !$parent.isMoneyballStickRank" id="auto-create-groups-of-tiers" class="btn btn-primary mr-2" type="button"
                    @click="$modal.show('auto-create-groups-of-tiers')"
                    :disabled="$parent.disableAutoCreateGroupsOfTiersButton">Auto-Create Groups of Tiers
                  </button>
                  <a href="#" v-show="!$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Show Chart Criteria Selections<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="$parent.displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Hide Chart Criteria Selections<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
            </div>            
            <div v-show="displayWinnersMap" class="form-row w-100">
              <winners ref="winnersRef" :survey-code="surveyCode" :client-chart-object="this.$parent.clientChart" :original-winner-type="winnerType"/>
            </div>
            <div v-if="displayValueRoadMapSetup" class="form-row w-100">
              <value-road-map-setup ref="valueRoadMapSetupRef" :input-use-equal-weight="useEqualWeight" :input-survey-group-id="surveyGroup" :input-period-id="period" :survey-code="surveyCode" :client-chart-object="this.$parent.clientChart" :original-winner-type="winnerType"
              :page-content="pageContent"/>
            </div>
          </div>
        </div>
      </form>
    </div>
    <counts-by-location ref="countsByLocation" :period="period.toString()"/>
    <manage-exclusion-list ref="manageExclusionList" type="Client"/>
  </div>
</template>
<script>
import $ from "jquery";
import jQuery from "jquery";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import ChartCriteriaSkeleton from "../../components/skeleton/ChartCriteriaSkeleton.vue";
import { reactive, toRaw } from 'vue'

import ChartCriteriaOption from "../../components/chart/ChartCriteriaOption.vue";
import ChartTypeCard from "../../components/chart/ChartTypeCard.vue";
import ChartCompany from "../../components/chart/ChartCompany.vue";
import Winners from "../../components/chart/Winners.vue";
import ValueRoadMapSetup from "../../components/chart/ValueRoadMapSetup.vue";
import Multiselect from "vue-multiselect";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import CountsByLocation from "../../modals/CountsByLocation.vue";
import ManageExclusionList from "../../modals/ManageExclusionList.vue";
import ChartService from "../../services/chart.service";
import ClientService from "../../services/client.service";
import AdminService from "../../services/admin.service";
import ErrorService from "../../services/error.service";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import GoogleService from "../../services/google.service";
import ClientCompetitorService from "../../services/client.competitor.service";
import WordCloudService  from "../../services/word.cloud.service";
import ReportService   from "../../services/report.service";
import ValueGroupMap from "../../services/chart/value.group.map.service";

import authHeader from "../../services/auth-header";
import Treeselect, { DirectionType, IconsType, OptionType, TreeselectValue } from 'vue-treeselectjs'
import 'vue-treeselectjs/dist/vue-treeselectjs.css'

export default {
  name: "ChartCriteria",
  components: {
    ChartCriteriaOption,
    ValueRoadMapSetup,
    Datepicker,
    ChartCompany,
    Multiselect,
    ChartTypeCard,
    Winners,
    ManageExclusionList,
    CountsByLocation,
    ChartCriteriaSkeleton,
    Treeselect
  },
  mixins: [ContentMixins, ChartCriteriaMixins],

  data() {
    return {
      period: "",
      defaultPeriod: "",
      endPeriod: "",
      comparativePeriods: [],
      comparativeSurveys: [],
      showNeeds: [],
      showMetrics: [],
      showMetricGroups: [],
      comparativeSurveyGroups: [],
      comparativeSavedCards: [],
      survey_options: [],
      show_needs_options: [],
      show_metrics_options: [],
      show_metric_groups_options: [],
      use_rank_calculations_options: [],
      rank_calculation_type: "",
      number_of_ranking_tiers_options: [],
      ranking_tier: "", 
      textDirection: "", 
      metric: "-1",
      displayType: "need",
      matchType: "",
      validator: null,
      chartForm: null,
      competitors: [],
      values: [],
      periodPrefix: "",
      competitor_options: [],
      display: false,
      saved_card_options: [],
      period_options: [],
      match_type_options: [],
      display_type_options: [],
      metric_options: [],
      displayBenchmark: false,
      includePartialResponses: "Y",
      useTTMAsStartDate: "Y",
      includeOrganizationSelectedInGroupRanks: false,
      customTimePeriod: false,
      customStartDate: new Date(),
      customEndDate: new Date().toLocaleDateString("en-US"),
      showAllChartCards: "N",
      showCompetitorExpectations: false,
      disableEqualWeightForComparativeSurveyGroups: true,
      showPricingPower: "Y",
      maximumComparative: 4,
      winnerType: "",
      displayCustomTimePeriod: true,
      eChartCriteria: {},
      moatRankOptions : ["total-moat-score","satisfaction"],
      baseRankOptions : ["w-score","emotional-needs","functional-needs","ideal-functional-needs","ideal-emotional-needs"] ,
      adminOnlyOptions: ["functional-needs","emotional-needs","ideal-functional-needs","ideal-emotional-needs"],
      showGrowthIdeas: "N",
      showGrowthMetrics: "N",
      showRelationshipStrength: "N",
      selectedMetricGroupByNeed: "",
      startPeriod: "",
      showPeriod: "",
      showRoadMapInitiatives: "N",
      defaultRoadMapInitiative: "Data-Driven",
      roadMapInitiative: "Data-Driven",
      roadmap_initiatives_options: [],
      disableShowFields: false,
      disableGrowthMetricsFields: true,
      disableRoadMapInitiativesFields: true,
      disableRelationshipStrengthFields: true,
    };
  },
  computed: {
    isAdmin: function() {
      return this.$parent.isAdmin;
    },
    disableIncludeOrganizationSelectedInGroupRanks: function() {
      return this.surveyGroup == "" || this.surveyGroup == null || this.surveyGroup == undefined; 
    },
    displayCustomDateFields: function() {
      return this.customTimePeriod == "Y" || this.customTimePeriod == "true" || this.customTimePeriod == true;
    },    
    showExclusionList: function() {
      return this.displayType == "nps"
    },
    totalComparative: function() {
      let total = 0;
      if (this.displayMultiSelectSurveyGroups || this.displayComparativeSurvey) {
        total = this.comparativeSurveys.length + this.comparativeSurveyGroups.length;
      } else if (this.displayComparativePeriod) {
        total = this.comparativePeriods.length;
      } else if (this.displaySavedCards) {
        total = this.comparativeSavedCards.length;
      }
      return total;
    },
    maximumCompetitorMessage: function() {
      return "Maximum of " + this.maximumCompetitors + " competitors. First remove a selected competitor to select another.";
    },
    displayWinnersMap: function() {
      return this.displayType == "winners";
    },
    displayValueRoadMapSetup: function() {
      return this.displayType == "value-roadmap";
    },
    showNpsTrends: function() {
      return this.displayType == "nps-trends";
    },
    displayMultiSelectSurveyGroups: function() {
      return this.matchType == "survey";
    },
    displaySingleSelectSurveyGroups: function() {
      return (!this.displayMultiSelectSurveyGroups && this.displayComparativePeriod) || !this.showMatchType;
    },
    displaySavedCards: function() {
      return this.matchType == "saved-card";
    },
    displayComparativePeriod: function() {
      return this.matchType == "time-period";
    },
    displayComparativeSurvey: function() {
      return this.matchType == "survey";
    },
    generateLabel: function(){
      if (this.displayType == "nps"){
        return "Analyze";
      } else if ((this.displayType == "need" || this.displayType == "value" ||
                  this.displayType == "winner" || this.displayType == "moat") && 
          this.isComparative == false){
        return "Analyze";
      }
      return "Analyze";
    },
    isNps: function(){
      return this.displayType == "nps" ;
    },
    isMoneyballStick: function(){
      return this.displayType == "moneyball-stick" ;
    },
    isValueRoadmap: function(){
      return this.displayType == "value-roadmap" ;
    },
    displayShowW30Benchmarks: function(){
      return !this.showNpsTrends && !(this.isRanks && this.displayType != "moat-rank") &&  this.displayType != "w-scores";
      //return !this.showNpsTrends && !this.isRanks;
    },
    displayUseRankCalculations: function(){
      return this.displayType == "w-scores-rank" && this.use_rank_calculations_options.length > 0;
    },
    isRanks: function(){
      return this.displayType == "nps-rank"
      || this.displayType == "satisfaction-rank"
      || this.displayType == "emotions-rank"
      || this.displayType == "moat-rank"
      || this.displayType == "w-scores-rank";
    },
    filteredShowNeedsOptions: function(){
      if (this.displayType == "moat-rank"){

        return this.show_needs_options
          .filter(option => !this.baseRankOptions.includes(option.value));
      }
      let showNeedsOptions = this.show_needs_options.filter(option => !this.moatRankOptions.includes(option.value));
      if (!this.isAdmin){
        showNeedsOptions = showNeedsOptions.filter(option => !this.adminOnlyOptions.includes(option.value));
      }
      return showNeedsOptions;
    },
    clientId: function() {
      if (typeof this.$parent.clientId != "undefined") {
        return this.$parent.clientId;
      } else {
        return 0;
      }
    },
    clientCode: function() {
      if (typeof this.$parent.clientCode != "undefined") {
        return this.$parent.clientCode;
      } else {
        return "";
      }
    },
    surveyCode: function() {
      if (typeof this.$parent.surveyCode != "undefined") {
        return this.$parent.surveyCode;
      } else {
        return "";
      }
    },
    surveyName: function() {
      return this.$parent.survey.name;
    },
    showCompetitors: function() {
      return  this.displayType != "nps-rank" &&
        this.displayType != "satisfaction-rank" &&
        this.displayType != "emotions-rank" &&
        this.displayType != "w-scores-rank" &&
        this.displayType != "w-scores";
    },
    hasCompetitors: function(){
      return this.competitor_options.length > 0;
    },
  },
  props: {
    showEndPeriod: {
      type: Boolean,
      default: false
    },    
    showUseTTMAsStartDate: {
      type: Boolean,
      default: false
    },
    showEqualWeight: {
      type: Boolean,
      default: true
    },    
    showCustomTimePeriod: {
      type: Boolean,
      default: true
    },   
    showIncludeOrganizationSelectedInGroupRanks: {
      type: Boolean,
      default: false
    }, 
    isComparative: {
      type: Boolean,
      value: false
    },
    useChartTypeCard: {
      type: Boolean,
      value: false
    },
    showMetric: {
      type: Boolean,
      value: false
    },
    showDisplayType: {
      type: Boolean,
      value: false
    },
    includeShowCompetitorExpectations: {
      type: Boolean,
      value: false
    },
    includeShowPricingPower: {
      type: Boolean,
      value: false
    },
    showMatchType: {
      type: Boolean,
      value: false
    },
    displayTypeLabel: {
      type: String,
      default: "Chart Type"
    },
    displayTypeModalName: {
      type: String,
      default: "Chart Type"
    },
    matchTypeLabel: {
      type: String,
      default: "By"
    },
    maximumCompetitors: {
      type: Number,
      default: 5
    },
    baseUrl: {
      type: String,
      default: AdminService.getBaseUrl()
    },
    timePeriodLabel: {
      type: String,
      default: "Period"
    },
    isProfilePage: {
      type: Boolean,
      value: false
    },
    isExplorePage: {
      type: Boolean,
      value: false
    },
  },
  methods: {
    onInput(value) {
      this.surveyLocation = value;
    },
    setDisableShowFields() {
      if (this.isExplorePage === true || this.isExplorePage === "true") {
          if (this.displayType.startsWith("functional-need-") || this.displayType.startsWith("emotional-need-")) {
            this.disableShowFields = false;
          } else {
            this.disableShowFields = true;
            this.showGrowthMetrics = "N";
            this.showGrowthIdeas = "N";
            this.showRelationshipStrength = "N";            
          }
      } else {
        this.disableShowFields = false;
      }
    },
    showManageExclusionListModal(){
      GoogleService.logManageExclusionList(this.$parent.chart.title, this.displayType, this.surveyName, this);
      this.$refs.manageExclusionList.loadData();
      this.$modal.show("manage-exclusion-list");
    },
    setTextDirection(inputTextDirection) {
      this.saveResultValue(inputTextDirection, "Text Direction", "text_direction", true);
      this.textDirection = inputTextDirection;
      if (typeof this.$parent.clientChart.criteria != "undefined" &&
                 this.$parent.clientChart.criteria.includes("text_direction")) {
        this.$parent.clientChart.criteria = 
          this.$parent.clientChart.criteria.replace("&text_direction=angle","&text_direction="+this.textDirection);
        this.$parent.clientChart.criteria = 
          this.$parent.clientChart.criteria.replace("&text_direction=horizontal","&text_direction="+this.textDirection);

      } else {
        this.$parent.clientChart.criteria = this.$parent.clientChart.criteria + "&text_direction="+this.textDirection;
      }
    },    
    runChart(){
      this.hasChartRun = true;
      this.setTotalMoatScoreAsDefaultForMoneyball();
      this.$parent.displayMainChart();
    },
    setDisplayType(inputDisplayType) {
      this.saveResultValue(inputDisplayType, "Display Type", "display_type", true);
      this.displayType = inputDisplayType;
      this.displayCustomTimePeriod =  this.displayType != 'trends';
      this.setTotalMoatScoreAsDefaultForMoneyball();
      this.$emit("reset-client-chart","");
      if (this.hasChartRun ==  true && this.displayType != "value-roadmap"){
/*        
        if (this.displayType != "value-roadmap"){
          this.$parent.displayMainChart();
        } else {
*/         
          let vm = this;
          setTimeout(function() {
            vm.$parent.displayMainChart();
          }, 1000);              
        //}
      } 
    },
    setUseEqualWeightForComparativeRemove: function(resetEqualWeight = false) {
      if (this.isComparative == false){
        return;
      }
      if (this.comparativeSurveyGroups.length != 0){
        this.disableEqualWeightForComparativeSurveyGroups = false;
      } else {
        this.disableEqualWeightForComparativeSurveyGroups = true;
        if (resetEqualWeight == true){
          this.useEqualWeight = "N";
        }
      }
    },
    onComparativeInput(inputOption, type) {
      let lastOption = toRaw(inputOption);
      if (type == "survey-group") {
        this.setUseEqualWeightForComparativeRemove(true);
      }
      if (this.totalComparative > this.maximumComparative) {
        if (type == "survey") {
          this.comparativeSurveys.pop();
        } else if (type == "survey-group") {
          this.comparativeSurveyGroups.pop();
        } else if (type == "time-period") {
          this.comparativePeriods.pop();
        } else if (type == "saved-card") {
          this.comparativeSavedCards.pop();
        }
        if (lastOption.checked == true) {
          lastOption.checked = false;
          return;
        }
        let message = "Only " + this.maximumComparative + " comparisons are allowed to be included in the chart";
        AdminService.displayErrorMessage({ text: message, duration: -1 });
      } else {
        if (typeof lastOption != "undefined") {
          lastOption.checked = true;
        }
      }
    },
    onComparativeRemove(inputOption, type) {
      let option = toRaw(inputOption);
      option.checked = false;
      let index = -1;
      if (type == "survey") {
        index = this.comparativeSurveys.findIndex(item => item.name == option.name);
        if (index >= 0) {
          this.comparativeSurveys[index].checked = false;
        }
      } else if (type == "survey-group") {
        index = this.comparativeSurveyGroups.findIndex(item => item.name == option.name);
        if (index >= 0) {
          this.comparativeSurveyGroups[index].checked = false;
        }
        this.setUseEqualWeightForComparativeRemove(true);
      } else if (type == "time-period") {
        index = this.comparativePeriods.findIndex(item => item.name == option.name);
        if (index >= 0) {
          this.comparativePeriods[index].checked = false;
        }
      } else if (type == "saved-cards") {
        index = this.comparativeSavedCards.findIndex(item => item.name == option.name);
        if (index >= 0) {
          this.comparativeSavedCards[index].checked = false;
        }
      }
    },
    updateValue: function(value) {
      this.$emit("input", value);
    },
    logChartClickEvent(widgetName, value){
      GoogleService.logChartClickEvent(this.$parent.chart.title, this.displayType, this.surveyName, widgetName, this);
    },
    resetCompetitors(){
      for (let i = 0; i < this.competitor_options.length; i++) {
        this.competitor_options[i].checked = false;
      }
    },
    resetChartCriteriaForRanks() {
      for (let i = 0; i < this.show_needs_options.length; i++) {
        this.show_needs_options[i].checked = false;
      }
      for (let i = 0; i < this.show_metrics_options.length; i++) {
        this.show_metrics_options[i].checked = false;
      }
      for (let i = 0; i < this.show_metric_groups_options.length; i++) {
        this.show_metric_groups_options[i].checked = false;
      }
      
      for (let i = 0; i < this.use_rank_calculations_options.length; i++) {
        this.use_rank_calculations_options[i].checked = false;
      }
      for (let i = 0; i < this.number_of_ranking_tiers_options.length; i++) {
        this.number_of_ranking_tiers_options[i].checked = false;
      }

    },    
    resetChartCriteria(setDefaults = true) {
      this.hasChartRun = false;
      this.$parent.$data.autoGenerateChartRun = false;
      this.$parent.setDisplayView(false);
      if (this.$refs.chartCompany !== undefined) {
        this.$refs.chartCompany.resetCompanySelections();
      }
      if (this.$parent.chart.typeName == "profile-match"){
        this.displayType == "need";
      }
      this.$parent.$refs.chartCriteriaResults.$data.criteriaResultsCompanyList = [];
      this.$parent.$refs.chartCriteriaResults.$data.criteriaResultsList = [];
      this.resetCriteriaResults();
      if (this.matchType != "survey"){
        this.setUseEqualWeight();
      }  else {
        this.setUseEqualWeightForComparativeRemove(true);
      }    
      if (this.isRanks){
        this.resetChartCriteriaForRanks();
      }
      this.resetCompetitors();
      if (setDefaults) {
        GoogleService.logResetCriteria(this.$parent.chart.title, this.displayType, this.surveyName, this);
        this.setDefaultValues();
      }
      // Reset Competitors
      this.values = [];

      // Reset all of the segments
      this.resetOption = !this.resetOption;

      $(".chart").html("");
      $(".chart-criteria-option").prop("checked", false);
    },
    getPeriodName(value) {
      if (this.period_options.length > 0) {
        let period = this.period_options.find(x => x.value == value);
        if (typeof period != "undefined") {
          return period.name;
        }
      }
      return "";
    },
    saveTimePeriod: function(value, group_label, parameterName, updateValue) {
      this.$parent.$data.clientChart.clientTimePeriodId = value;
      this.saveResultValue(value, group_label, parameterName, updateValue);
    },
    saveTimePeriodEvent: function(event, group_label, parameterName, updateValue) {
      this.$parent.$data.clientChart.clientTimePeriodId = event.target.value;
      this.saveResultValue(event.target.value, group_label, parameterName, updateValue);
    },
    buildUrlParams(client_id) {
      let params = new URLSearchParams();
      if (this.displayWinnersMap) {
        this.$refs.winnersRef.setupWinnersMapForSave();
        if (typeof this.$parent.clientChart != "undefined" && (this.$parent.clientChart.clientChartId == 0 || this.$parent.clientChart.displayType == "winners")) {
          params.append("clientChartId", this.$parent.clientChart.clientChartId);
        }
        params.append("conserveEfforts", JSON.stringify(this.$refs.winnersRef.conserveEfforts));
        params.append("coreEfforts", JSON.stringify(this.$refs.winnersRef.coreEfforts));
        params.append("divergeEfforts", JSON.stringify(this.$refs.winnersRef.divergeEfforts));
        params.append("winnerTypeSelected", this.$refs.winnersRef.winnerTypeSelected);
      } else if (this.displayValueRoadMapSetup) {
        this.$refs.valueRoadMapSetupRef.setupValueGroupMapSetupForSave();
        if (typeof this.$parent.clientChart != "undefined" && (this.$parent.clientChart.clientChartId == 0 || this.$parent.clientChart.displayType == "value-roadmap")) {
          params.append("clientChartId", this.$parent.clientChart.clientChartId);
        }
        params.append("valueRoadMapId", this.$refs.valueRoadMapSetupRef.valueRoadMapId);
        let focusAreaEfforts = ValueGroupMap.removeNodes(this.$refs.valueRoadMapSetupRef.focusAreaEfforts);
        let otherAreaEfforts = ValueGroupMap.removeNodes(this.$refs.valueRoadMapSetupRef.otherAreaEfforts);
        params.append("focusAreaEfforts", JSON.stringify(focusAreaEfforts));
        params.append("otherAreaEfforts", JSON.stringify(otherAreaEfforts));
      }
      if (this.showEndPeriod) {
        params.append("endPeriod", this.endPeriod);
      }
      params.append("client_id", client_id);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("show_public_groups", this.showPublicGroups);
      var competitors = this.competitors;
      var competitorsLength = competitors.length;
      for (var i = 0; i < competitorsLength; i++) {
        if (competitors[i].companyType == "benchmark") {
          params.append("benchmark_company_id", competitors[i].companyId);
        } else {
          params.append("competitor_company_id", competitors[i].companyId);
        }
      }
      for (var savedCardsIndex = 0; savedCardsIndex < this.comparativeSavedCards.length; savedCardsIndex++) {
        params.append("comparative_saved_card", this.comparativeSavedCards[savedCardsIndex].clientChartId);
      }
      for (var t = 0; t < this.comparativePeriods.length; t++) {
        params.append("comparative_period", this.comparativePeriods[t].value);
      }
      for (var surveyIndex = 0; surveyIndex < this.comparativeSurveys.length; surveyIndex++) {
        params.append("comparative_survey", this.comparativeSurveys[surveyIndex].value);
      }
      params = this.buildCriteriaUrl(params);
      for (var surveyGroupIndex = 0; surveyGroupIndex < this.comparativeSurveyGroups.length; surveyGroupIndex++) {
        params.append("comparative_survey_group", this.comparativeSurveyGroups[surveyGroupIndex].value);
      }
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "eChartType")) {
        params.append("eChartType",this.eChartCriteria.eChartType);
	    }
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showTooltip")) {
        params.append("showTooltip",this.eChartCriteria.showTooltip);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "displayNumberOfResponses")) {
        params.append("displayNumberOfResponses",this.eChartCriteria.displayNumberOfResponses);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "sortBy")) {
        params.append("sortBy",this.eChartCriteria.sortBy);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "angleText")) {
        params.append("angleText",this.eChartCriteria.angleText);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showGoalLine")) {
        params.append("showGoalLine",this.eChartCriteria.showGoalLine);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showLegend")) {
        params.append("showLegend",this.eChartCriteria.showLegend);
	    }
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "showLabels")) {
        params.append("showLabels",this.eChartCriteria.showLabels);
      }	        
      if (Object.prototype.hasOwnProperty.call(this.eChartCriteria, "colorPaletteId")) {
        params.append("colorPaletteId",this.eChartCriteria.colorPaletteId);
      }	        
      return params;
    },
    loadClients(response) {
      this.clientOptions = response.data;
    },
    loadOptions(response) {
      this.$root.processServerResponse();
      this.defaultPeriod = response.data.defaultPeriod;
      let returnChartCriteriaList = response.data.returnChartCriteriaList
      for (var i in returnChartCriteriaList) {
        this.criteriaResults.push(returnChartCriteriaList[i]);
      }
      this.surveyGroupList = response.data.surveyGroupList;
      this.segments = ChartService.getSegments(this.criteriaResults);
      this.survey_group_options = this.getSurveyGroupOptions();
      this.period_options = this.findCriteria("Period").options;
      this.saved_card_options = ClientService.getSavedChartsByChartType(this.$parent.clientObject.clientCharts, this.$parent.survey.surveyId, 1);
      this.saved_card_options.sort(ReportService.compareValues("name", "asc"));
      this.display_type_options = this.findCriteria("Display Type").options;
      this.match_type_options = this.findCriteria("Match Type").options;
      if (this.$parent.chart.typeName == "competitive-trends") {
        this.displayType = "trends";
        this.metric_options = this.findCriteria("Metric").options;
        this.metric = "-1";
      } else if (this.$parent.chart.typeName == "competitive-profile") {
        this.show_metric_groups_options = this.findCriteria("Show Metric Groups").options;
        this.period_options = this.findCriteria("Start Period").options;
        ClientService.getSavedChartsByClientId(this.clientId, this.getSavedChartsByClientIdCallback, this);
      } else if (this.$parent.chart.typeName == "ranks") {
        this.displayType = "moat-rank";
        this.displayCustomTimePeriod = true;
        this.show_needs_options = this.findCriteria("Show Needs").options;
        this.show_metrics_options = this.findCriteria("Show Metrics").options;
        this.show_metric_groups_options = this.findCriteria("Show Metric Groups").options;
        this.use_rank_calculations_options = this.findCriteria("Use Rank Calculations").options;
        this.number_of_ranking_tiers_options= this.findCriteria("# of Ranking Tiers").options;
        this.ranking_tier = "";
        this.rank_calculation_type = "";
      } else if (this.$parent.chart.typeName == "profile-match") {
        this.displayType = "need";
        this.matchType = "survey";
        this.survey_options = this.findCriteria("Survey").options;
      } else if (this.$parent.chart.typeName == "predictive-analytics") {
        this.displayType = "analytics";
      }
    },
    loadCompetitors(data) {
      this.competitor_options = data;
      for (var index = 0; index < this.competitor_options.length; index++) {
        this.competitor_options[index]["checked"] = false;
        var competitorOption = this.competitor_options[index];
        var competitorOptionMatch = this.values.find(x => Number(x.companyId) === Number(competitorOption.companyId));
        if (typeof competitorOptionMatch != "undefined") {
          competitorOptionMatch.name = this.competitor_options[index]["name"];
          this.competitor_options[index]["checked"] = true;
        }
      }
    },
    setTotalMoatScoreAsDefaultForMoneyball(){
      let defaultFound = false;
      let defaultValue = this.showNeeds.find(x => x.value === "total-moat-score");
      if (typeof defaultValue != "undefined"){
        defaultFound = true;
      }
      if (this.displayType == "moat-rank" && defaultFound == false){
        // set the default checkbox to checked
        for (let optionIndex = 0; optionIndex < this.filteredShowNeedsOptions.length; optionIndex++) {
          let option = this.filteredShowNeedsOptions[optionIndex];
          if (option.value == "total-moat-score"){
            option.checked = true;
            // make sure the entry isn't there already
            var match = this.showNeeds.find(x => x.value === option.value);
            if (typeof match === "undefined") {
              // add the entry to the list
              this.showNeeds.push(option);
            } 
          }
        }
      }
    },
    resetShowNeeds(){
      for (let optionIndex = 0; optionIndex < this.showNeeds.length; optionIndex++) {
        let option = this.showNeeds[optionIndex];
        let found = false;
        for (let filteredOptionIndex = 0; filteredOptionIndex < this.filteredShowNeedsOptions.length; filteredOptionIndex++) {
          let filteredOption = this.filteredShowNeedsOptions[filteredOptionIndex];
          if (filteredOption.value == option.value){
            found = true;
            break;
          }
        }
        if (found == false){
          option.checked = false;
          var match = this.showNeeds.find(x => x.value === option.value);
          if (typeof match !== "undefined") {
            this.showNeeds.splice($.inArray(match, this.showNeeds), 1);
          }
        }
      }
      this.setDisableShowFields();       
/*      
      if (this.displayType == "moat-rank" && this.showNeeds.length == 0){
        // set the default checkbox to checked
        for (let optionIndex = 0; optionIndex < this.filteredShowNeedsOptions.length; optionIndex++) {
          let option = this.filteredShowNeedsOptions[optionIndex];
          if (option.value == "total-moat-score"){
            option.checked = true;
            this.showNeeds.push(option);
          }
        }
      }
*/        
    },
    setDefaultValues() {
      this.period = this.defaultPeriod;
      this.endPeriod = this.defaultPeriod;
      this.customStartDate = new Date().toLocaleDateString("en-US");
      this.customEndDate = new Date().toLocaleDateString("en-US");
      this.saveTimePeriod(this.period, "Period", "period", true);
      this.saveResultValue(this.displayType, "Display Type", "display_type", true);
      this.saveResultValue(this.matchType, "Match Type", "match_type", true);
      
      this.customTimePeriod = false;
      this.useEqualWeight = "N";
      this.includePartialResponses = "Y";
      this.useTTMAsStartDate = "Y";
      this.includeOrganizationSelectedInGroupRanks = false;
      this.showCompetitorExpectations = false;
      this.showPricingPower = "Y";
      this.saveResultValue(this.includePartialResponses, "Include Partial Responses", "include_partial_responses", true);
      this.saveResultValue(this.showPricingPower, "Show Willingness to Pay by Need", "show_pricing_power", true);
      this.saveResultValue(this.useTTMAsStartDate, "Use TTM as Data Start Date", "use_ttm_as_data_start_date", true);
      this.surveyGroup = [];
      this.displayBenchmark = false;
      this.metric = -1;
      this.comparativeSurveyGroups = [];
      this.surveyLocation = [];
      this.words = [];
      this.showNeeds = [];
      this.showMetrics = [];
      this.showMetricGroups = [];
      this.ranking_tier = "";
      this.rank_calculation_type = "";
      this.textDirection = "";
      for (let optionIndex = 0; optionIndex < this.survey_group_options.length; optionIndex++) {
        let option = this.survey_group_options[optionIndex];
        option.checked = false;
      }

      this.comparativeSurveys = [];
      for (let optionIndex = 0; optionIndex < this.survey_options.length; optionIndex++) {
        let option = this.survey_options[optionIndex];
        option.checked = false;
      }
      this.resetShowNeeds();
      this.showMetrics = [];
      for (let optionIndex = 0; optionIndex < this.show_metrics_options.length; optionIndex++) {
        let option = this.show_metrics_options[optionIndex];
        option.checked = false;
      }
      this.showMetricGroups = [];
      for (let optionIndex = 0; optionIndex < this.show_metric_groups_options.length; optionIndex++) {
        let option = this.show_metric_groups_options[optionIndex];
        option.checked = false;
      }
      
      this.comparativePeriods = [];
      for (let optionIndex = 0; optionIndex < this.period_options.length; optionIndex++) {
        let option = this.period_options[optionIndex];
        option.checked = false;
      }
      this.comparativeSavedCards = [];
      for (let optionIndex = 0; optionIndex < this.saved_card_options.length; optionIndex++) {
        let option = this.saved_card_options[optionIndex];
        option.checked = false;
      }
      this.displayCustomTimePeriod =  this.displayType != 'trends';
      this.showGrowthIdeas = "N";
      this.saveResultValue(this.showGrowthIdeas, "Show Growth Ideas", "show_growth_ideas", true);
      this.showGrowthMetrics = "N";
      this.saveResultValue(this.showGrowthMetrics, "Show Growth Metrics", "show_growth_metrics", true);
      this.showRelationshipStrength = "N";
      //this.saveResultValue(this.showRelationshipStrength, "Show Relative Strength", "show_relative_strength", true);
      this.showRoadMapInitiatives = "N";
      this.saveResultValue(this.showRoadMapInitiatives, "Show Initiatives by Need", "show_roadmap_initiatives", true);
    },
    processPartialResponsesCallback: function(response) {},
    async loadData(chartTypeName) {
      let surveyId = SurveyService.getSurveyId();
      if (surveyId != 0) {        
        this.$root.processServerRequest("Loading data");
        const params = new URLSearchParams();
        params.append("client_id", this.clientId);
        params.append("survey_id", surveyId);
        params.append("user_id", UserService.getUserId());
        params.append("chart_type_name", chartTypeName);
        await axios
          .post(this.baseUrl + "/api/v1/chart/get-options", params, { headers: await authHeader() })
          .then(response => this.loadOptions(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("ChartCriteria.loadData.get-options", error, "chart", this);
          });
      }
      if (!this.$parent.autoGenerateChartRun) {
        this.setDefaultValues();
      }
      this.setupChart();
      this.$parent.processAutoGenerateChart();
      if (this.matchType != "survey"){
        this.setUseEqualWeight();
      }  else {
        this.setUseEqualWeightForComparativeRemove();
      }    
      this.display = true;
      this.$root.processServerResponse();
      this.setTotalMoatScoreAsDefaultForMoneyball();
    },
    setupChart() {
      this.chartForm = $("#ChartGenerateFormId");

      jQuery.validator.setDefaults({
        debug: true,
        success: "valid"
      });
      jQuery.validator.addMethod(
        "notEqual",
        function(value, element, param) {
          return this.optional(element) || value != param;
        },
        "Please choose a value!"
      );

      this.validator = this.chartForm.validate({
        rules: {},
        highlight: function(element) {
          $(element)
            .closest(".form-group")
            .removeClass("has-success")
            .addClass("has-error");
        },
        unhighlight: function(element) {
          $(element)
            .closest(".form-group")
            .removeClass("has-error")
            .addClass("has-success");
        },
        errorElement: "small",
        errorClass: "form-text text-danger",
        errorPlacement: function(error, element) {
          if (element.length) {
            var targetParent = $(element).parent();
            if (targetParent.hasClass("form-check") || targetParent.hasClass("custom-control")) {
              targetParent = targetParent.parent();
            }
            targetParent.append(error);
          }
        }
      });
    },
    removeCompany(competitor) {
      var competitorToDelete = $("div[data-company-id='" + competitor.companyId + "']");
      if (competitorToDelete !== "undefined" && competitorToDelete.length > 0) {
        competitorToDelete.html("");
      }
      var match = this.competitors.find(x => Number(x.companyId) === Number(competitor.companyId));
      if (typeof match !== "undefined") {
        this.competitors.splice($.inArray(match, this.competitors), 1);
        let company = this.$refs.competitorsSelect.options.find(x => Number(x.companyId) === Number(competitor.companyId));
        if (typeof company !== "undefined") {
          company.checked = false;
        }
      }
    },
    addCompany(competitor) {
      competitor.checked = true;
      // Only add if the company doesn't already exist
      var match = this.competitors.find(x => Number(x.companyId) === Number(competitor.companyId));
      if (typeof match == "undefined") {
        this.competitors.push(competitor);
      }
    },
    select(option) {
      option.selected = !option.selected;
    },
    addMetric(metric) {
      metric.checked = true;
    },
    removeMetric(metric) {
      metric.checked = false;
      let showMetricsCriteria = this.findCriteriaByParameter("show_metric_groups");
      if (typeof showMetricsCriteria != "undefined") {
        let valueToRemove = showMetricsCriteria.values.find(x => x === metric.value);
        if (typeof valueToRemove !== "undefined") {
          showMetricsCriteria.values.splice($.inArray(showMetricsCriteria, showMetricsCriteria.values), 1);
        }      
      }      
    },    
    addNeed(need) {
      need.checked = true;
    },
    removeNeed(need) {
      need.checked = false;
      let showNeedsCriteria = this.findCriteriaByParameter("show_needs");
      if (typeof showNeedsCriteria != "undefined") {
        let valueToRemove = showNeedsCriteria.values.find(x => x === need.value);
        if (typeof valueToRemove !== "undefined") {
          showNeedsCriteria.values.splice($.inArray(valueToRemove, showNeedsCriteria.values), 1);
        }      
      }
    },
    setSurveyCode(){
      if (this.$parent.autoGenerateChart) {
        this.hideChartCriteriaSections();
        if (typeof this.$parent.clientChart != "undefined") {
          if (typeof this.$parent.clientChart.criteria != "undefined" && this.$parent.clientChart.criteria != "") {
            let criteriaParametersList = this.$parent.clientChart.criteria.split("&");
            // find survey id
            for (let criteriaIndex = 0; criteriaIndex < criteriaParametersList.length; criteriaIndex++) {
              let criteria = criteriaParametersList[criteriaIndex];
              let criteriaParameters = criteria.split("=");
              let defaultParameter = criteriaParameters[0];
              let defaultValue = criteriaParameters[1];
              if (defaultParameter == "survey_id") {
                if (this.$parent.survey.surveyId != defaultValue) {
                  let newSurveyCode = SurveyService.getSurveyCodeBySurveyId(defaultValue);
                  if (newSurveyCode != "") {
                    this.$parent.surveyCode = newSurveyCode;
                    this.$parent.$parent.$parent.surveyCode = newSurveyCode;
                    SurveyService.setSurveyCode(newSurveyCode);
                    this.$root.setSurveyCode(newSurveyCode);
                    this.$parent.survey = SurveyService.getSurvey();
                  }
                }
              }
            }
          }
        }
      }
    },
    selectMetricGroupByNeed: function(event) {
      this.showMetricGroups = [];
      this.saveResultValue(this.selectedMetricGroupByNeed, "Show Metric Groups", "show_metric_groups", true);
    },
    resetGrowthMetricsFields:function() {
      if (this.showGrowthMetrics == "N") {
        this.disableGrowthMetricsFields = true;
        this.showPeriod = "";
      } else {
        this.disableGrowthMetricsFields = false;
        if (this.showPeriod == ""){
          this.showPeriod = this.period;
        }
      }
      this.saveResultValue(this.showGrowthMetrics, "Show Growth Metrics", "show_growth_metrics", true);
    },
    resetRelationshipStrengthFields: function() {
      if (this.showRelationshipStrength == "N") {
        this.selectedMetricGroupByNeed = "";
        this.disableRelationshipStrengthFields = true;
        this.showMetricGroups = [];
        this.startPeriod = "";
      } else {
        this.disableRelationshipStrengthFields = false;
      }
      this.saveResultValue(this.showRelationshipStrength, "Show Relative Strength", "show_relative_strength", true);
      this.saveResultValue(this.selectedMetricGroupByNeed, "Show Metric Groups", "show_metric_groups", true);
      this.selectStartPeriod();
      this.selectShowPeriod();
    },
    selectStartPeriod: function() {
      this.saveResultValue(this.startPeriod, "Start Period", "startPeriod", true);
    },
    selectShowPeriod: function() {
      this.saveResultValue(this.showPeriod, "Show Period", "showPeriod", true);
    },
    resetRoadMapInitiativesFields: function() {
      if (this.showRoadMapInitiatives == "N") {
        this.roadMapInitiative = this.defaultRoadMapInitiative;
        this.disableRoadMapInitiativesFields = true;
      } else {
        this.disableRoadMapInitiativesFields = false;
      }
      this.saveResultValue(this.showRoadMapInitiatives, "Show Initiatives by Need", "show_roadmap_initiatives", true);
      this.selectRoadMapInitiative();
    },
    selectRoadMapInitiative: function() {
      this.saveResultValue(this.roadMapInitiative, "RoadMap Initiative", "roadmap_initiative", true);
    },
    getSavedChartsByClientIdCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let data = response.data.data;
        let saved_card_options = [];
        for (var i = 0; i < data.length; i++) {
          saved_card_options.push({ clientChartId: data[i].clientChartId, value: String(data[i].clientChartId), name: data[i].name, chartTypeId: data[i].chartTypeId, displayType: data[i].displayType, clientId: data[i].clientId });
        }
        saved_card_options.sort(ReportService.compareValues("name", "asc"));
        this.loadSegments(saved_card_options);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },  
    loadSegments(data) {
      //console.log("DashboardValueRoadMap::loadSegments data " + JSON.stringify(data));
      this.roadmap_initiatives_options = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].displayType == "value-roadmap"){
          this.roadmap_initiatives_options.push({ value: data[i].clientChartId, name: data[i].name });
        }
      }
      this.initialMapCardsLoaded = true;
    },
    getWordCountsCallback:function(response){}
  },
  watch: {
    displayType: function(){
      if (this.displayShowW30Benchmarks == false) {
        this.displayBenchmark = false;
/*        
        if (this.$refs.chartCompany !== undefined) {
          this.$refs.chartCompany.resetCompanySelections();
        }
*/          
      }
      this.resetShowNeeds();
    },
    customTimePeriod: function() {
      if (this.customTimePeriod == true || this.customTimePeriod == "Y"){
        this.saveResultValue(this.customStartDate, "Custom Start Date", "custom_start_date", true);
        this.saveResultValue(this.customEndDate, "Custom End Date", "custom_end_date", true);
      } else {
        this.resetCustomFields();
      }
    },
    showAllChartCards: function() {
      if (this.showAllChartCards == "N") {
        this.saved_card_options = ClientService.getSavedChartsByChartType(this.$parent.clientObject.clientCharts, this.$parent.survey.surveyId, 1);
        this.saved_card_options.sort(ReportService.compareValues("name", "asc"));
      } else {
        this.saved_card_options = ClientService.getAllSavedChartsByChartType(this.$parent.clientObject.clientCharts, 1);
        this.saved_card_options.sort(ReportService.compareValues("name", "asc"));
      }
    },
    displayBenchmark: function() {
      this.$refs.chartCompany.$data.displayBenchmark = this.displayBenchmark;
    },
    surveyCode: function() {
      if (this.$refs.chartCompany !== undefined) {
        this.$refs.chartCompany.resetCompanySelections();
      }
      if (!this.$parent.autoGenerateChartRun) {
        this.criteriaResults = [];
        this.resetChartCriteria(false);
        this.loadData(this.$parent.chart.typeName);
      }
    },
    comparativeSavedCards: function() {
      if (this.comparativeSavedCards.length > this.maximumCompetitors) {
        event.preventDefault();
        let message = "Only " + this.maximumCompetitors + " saved cards are allowed to be included in the chart";
        AdminService.displayErrorMessage({ text: message, duration: -1 });
      } 
    },
    comparativePeriods: function() {
      if (this.comparativePeriods.length > this.maximumCompetitors) {
        event.preventDefault();
        let message = "Only " + this.maximumCompetitors + " time periods are allowed to be included in the chart";
        AdminService.displayErrorMessage({ text: message, duration: -1 });
      } 
    },
    comparativeSurveys: function() {
      if (this.comparativeSurveys.length > this.maximumComparative) {
        event.preventDefault();
        let message = "Only " + this.maximumComparative + " surveys are allowed to be included in the chart";
        AdminService.displayErrorMessage({ text: message, duration: -1 });
      } 
    },
    comparativeSurveyGroups: function() {
      if (this.comparativeSurveyGroups.length > this.maximumComparative) {
        event.preventDefault();
        let message = "Only " + this.maximumComparative + " surveys are allowed to be included in the chart";
        AdminService.displayErrorMessage({ text: message, duration: -1 });
      } 
    },
    period: async function() {
      ClientCompetitorService.getCompetitors(this.clientId, this.period, this.useTTMAsStartDate, this.loadCompetitors, !this.isExplorePage);
//      ChartService.getSurveyLocations(this.baseUrl, SurveyService.getSurveyId(), this.period, true, this.getSurveyLocationsCallback);
      WordCloudService.getWordCounts(SurveyService.getSurveyId(), this.period, true, this.useTTMAsStartDate,this.getWordCountsCallback);
    },
    matchType: function() {},
    disableChartCriteriaWidgets: function() {
      this.setDisableShowFields();
      $("#ChartGenerateFormId :input").prop("disabled", this.disableChartCriteriaWidgets);
      if (this.matchType != "survey"){
        this.setUseEqualWeight();
      }  else {
        this.setUseEqualWeightForComparativeRemove();
      }    
      $("#useEqualWeight").prop("disabled", this.disableEqualWeight);
      $("#useEqualWeightForComparativeSurveyGroups").prop("disabled", this.disableEqualWeightForComparativeSurveyGroups);      
      if(this.disableRelationshipStrengthFields) {
        $("#showMetricGroupsByNeed").prop("disabled", this.disableRelationshipStrengthFields);  
        $("#startPeriod").prop("disabled", this.disableRelationshipStrengthFields);
      }
      if(this.disableRoadMapInitiativesFields) {
        $("#roadMapInitiative").prop("disabled", this.disableRoadMapInitiativesFields);
      }
      if (this.disableGrowthMetricsFields) {
        $("#showGrowthMetrics").prop("disabled", this.disableGrowthMetricsFields);
        $("#showPeriod").prop("disabled", this.disableGrowthMetricsFields);
      }
      if (this.disableShowFields == false){
        $("#showGrowthMetrics").prop("disabled", false);
        $("#showGrowthIdeas").prop("disabled", false);
        $("#showRelationshipStrength").prop("disabled", false);
      } else {
        $("#showGrowthMetrics").prop("disabled", true);
        $("#showGrowthIdeas").prop("disabled", true);
        $("#showRelationshipStrength").prop("disabled", true);
      }
    },
    showRelationshipStrength: function() {
      this.resetRelationshipStrengthFields();
    },
    showRoadMapInitiatives: function() {
      this.resetRoadMapInitiativesFields();
    },
    showGrowthMetrics: function() {
      this.resetGrowthMetricsFields();
    },
  },
  mounted() {},
  created() {
    this.getPageContent("Chart");
    this.loadData(this.$parent.chart.typeName);
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
